import styled, { css } from "styled-components/macro";

export const StyledResponsiveImage = styled.img(({ theme }) => {
  return css`
    display: block;
    width: 100%;
    max-width: 100%;
  `;
});
